import pageImage from "AdvisoryManagement/Assets/Images/ELIS.png";

export const ElisPage = () => {
	return (
		<img
			src={pageImage}
			alt="ELIS"
			style={{ maxWidth: "100%", height: "auto" }}
		/>
	);
};
